module.exports = require('./helpers/bundle-url').getBundleURL('e2rTN') + "logo-dark.eefe0b7f.svg";